<template>
  <div class="about">
    <OfficeSection />
    <CEO />
  </div>
</template>

<script>
import OfficeSection from "@/components/about/OfficeSection.vue";
import CEO from "@/components/about/CEO.vue";
export default {
  components: {
    OfficeSection,
    CEO,
  },
};
</script>

<style lang="scss" scoped>
.about {
  margin-top: 6rem !important;

  @include media-breakpoint-down(md) {
    margin-top: 5.5rem;
  }
}
</style>
